import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ProductTabsPlaceholder from './ProductTabsPlaceholder'
import ReactPlaceholder from 'react-placeholder'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import 'react-rater/lib/react-rater.css'
import 'react-tabs/style/react-tabs.css'
import '@loyal_template/rating.css'
import '@loyal_template/storerating.css'

class ProductTabs extends Component {
  state = { showModal: false }
  state = { hideModal: true }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  render () {
    const { description, properties, specs } = this.props
    const hasProperties = !!properties.length
    const hasSpecs = !!specs.length

    return (
      <ReactPlaceholder
        ready={!this.props.isLoading}
        customPlaceholder={<ProductTabsPlaceholder />}
      >
        <Tabs className={`product-tabs border-color-ui-3 mt-0 mt-md-3`}>
          <div className='tabs-area draggable border-color-ui-3 border-bottom px-2 mx-0'>
            <div className='draggable-item d-inline-block px-half'>
              <TabList className='tabs-item py-3 px-0 mx-0'>
                {description && (
                  <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'>
                    Informações
                  </Tab>
                )}
                {hasProperties && (
                  <Tab
                    className={`item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3`}
                  >
                    Características
                  </Tab>
                )}
                {hasSpecs && (
                  <Tab className='item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'>
                    Especificações
                  </Tab>
                )}
              </TabList>
            </div>
          </div>

          {description && (
            <TabPanel className='tabeffect row px-2 mx-0'>
              <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
                <p
                  className='txt-body-sm'
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>
            </TabPanel>
          )}

          {hasProperties && (
            <TabPanel className={`tabeffect row px-2 mx-0`}>
              <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
                <ul>
                  {this.props.properties.map((property, index) => (
                    <li key={index}>
                      <strong className='txt-body-sm color-ui-1'>
                        {property.name}:
                      </strong>
                      <div
                        className='txt-body-sm color-ui-1'
                        dangerouslySetInnerHTML={{ __html: property.value }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </TabPanel>
          )}

          {hasSpecs && (
            <TabPanel className='tabeffect row px-2 mx-0'>
              <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
                <ul>
                  {this.props.specs
                    ? this.props.specs.map((property, index) => (
                      <li key={index}>
                        <strong className='txt-body-sm color-ui-1'>
                          {property.name}:
                        </strong>
                        <div
                          className='txt-body-sm color-ui-1'
                          dangerouslySetInnerHTML={{ __html: property.value }}
                        />
                      </li>
                    ))
                    : ''}
                </ul>
              </div>
            </TabPanel>
          )}
        </Tabs>
      </ReactPlaceholder>
    )
  }
}

ProductTabs.propTypes = {
  isLoading: PropTypes.bool,
  description: PropTypes.string,
  properties: PropTypes.array,
  specs: PropTypes.array
}

export default ProductTabs



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/DetailSection/ProductTabs/ProductTabs.js